import * as Sentry from '@sentry/react'

Sentry.init({
  dsn: 'https://2409060fc5dcc5e9b88bea9eafa309d9@o112361.ingest.us.sentry.io/4511269272420352',
  environment: process.env.AUTH_PF_ENV,
  enabled: Boolean(process.env.SENTRY_ENABLED),
  // ...
  // Note: if you want to override the automatic release value, do not set a
  // `release` value here - use the environment variable `SENTRY_RELEASE`, so
  // that it will also get attached to your source maps
})
